import { UUID } from 'crypto'
import { PaymentDto } from '../../pages/users/api/dto/get/PaymentDto'
import { PaymentUI } from '../../pages/users/model/PaymentUI'

class Payment {
  private constructor(
    id: UUID,
    studentId: UUID,
    paid: number,
    description: string | undefined,
  ) {
    this.id = id
    this.studentId = studentId
    this.paid = paid
    this.description = description ? description : ''
  }

  private readonly id: UUID
  private readonly studentId: UUID
  private readonly paid: number
  private readonly description: string

  toPaymentUI(): PaymentUI {
    return {
      id: this.id,
      studentId: this.studentId,
      paid: this.paid,
      description: this.description,
    } satisfies PaymentUI
  }

  static fromDto(paymentDto: PaymentDto): Payment {
    const { id, studentId, paid, description } = paymentDto
    return new Payment(id, studentId, paid, description)
  }
}

export default Payment
